import { render, staticRenderFns } from "./footerComponent-socials.vue?vue&type=template&id=96fc3464&scoped=true&"
import script from "./footerComponent-socials.vue?vue&type=script&lang=js&"
export * from "./footerComponent-socials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fc3464",
  null
  
)

export default component.exports